module.exports = __webpack_public_path__ + "img/jira.24ebbc44.svg";